/* eslint-disable */
import { defineStore } from 'pinia';
import { useSocketStore } from './socket';
import { useHistoryStore } from './history';
// const socketStore = useSocketStore();


export const useHistoryBetsStore = defineStore('historyBets', {
	state: () => ({

	}),
	getters: {

	},
	actions: {
		joinBetslipsSnapshot() {
			const historyStore = useHistoryStore();
			const socketStore = useSocketStore();
			const my_bets = [];
			historyStore.getUnsettledBets.data.forEach(betslip => {
				betslip.bets.forEach(bet => {
					my_bets.push({ fixture_id: bet.fixture_id, odd_uuid: bet.uuid })
				});
			});

			socketStore.join('myBetsSnapshot', my_bets);
		},
		leaveOldBets(old_history) {
			old_history.forEach(betslip => {
				betslip.bets.forEach(bet => {
					this.tryleaveFixtureOddInfo({'fixture_id': bet.fixture_id, 'odd_uuid': bet.uuid})
				});
			});

		},
		tryleaveFixtureOddInfo(payload) {
			const socketStore = useSocketStore();
			const historyStore = useHistoryStore();
			let found = false;
			for (const betslip of historyStore.getUnsettledBets.data) {
				let bet = _.find(betslip.bets, { uuid: payload.odd_uuid });
				if (bet) {
					found = true;
					break;
				}
			}

			if (!found) socketStore.leave('fixtureOddInfo', { fixture_id: payload.fixture_id, odd_uuid: payload.odd_uuid })
		},
		leaveAllOddInfos() {
			const socketStore = useSocketStore();
			const historyStore = useHistoryStore();
			const my_bets = [];
			for (const betslip of historyStore.getUnsettledBets.data) {
				betslip.bets.forEach(bet => {
					my_bets.push({ fixture_id: bet.fixture_id, odd_uuid: bet.uuid })
				});
			}

			for (const bet of my_bets) {
				socketStore.leave('fixtureOddInfo', { fixture_id: bet.fixture_id, odd_uuid: bet.odd_uuid })
			}
		},
		setMyBetsSnapshot(payload) {
			const historyStore = useHistoryStore();
			historyStore.unsettled_bets.data.forEach((betslip, betslip_index) => {
				betslip.bets.forEach((bet, bet_index) => {
					if (payload[bet.uuid]) {
						historyStore.unsettled_bets.data[betslip_index].bets[bet_index].live = payload[bet.uuid].live;
						historyStore.unsettled_bets.data[betslip_index].bets[bet_index].status = payload[bet.uuid].status;
						historyStore.unsettled_bets.data[betslip_index].bets[bet_index].statistics = payload[bet.uuid].statistics;
						historyStore.unsettled_bets.data[betslip_index].bets[bet_index].virtual_live_id = payload[bet.uuid].virtual_live_id;
						if (!bet.settlement && !bet.current_price) {
							historyStore.unsettled_bets.data[betslip_index].bets[bet_index].current_price =  payload[bet.uuid].price;
						}
					} else {
						// Change price only if betslip is not settled
						// if (bet.settlement != null) this.my_bets[betslip_index].bets[bet_index].current_price = null;
					}
				});
			});

		},
		setFixtureOddInfo(payload) {
			const historyStore = useHistoryStore();
			historyStore.unsettled_bets.data.forEach((betslip, betslip_index) => {
				betslip.bets.forEach((bet, bet_index) => {
					if (bet.uuid == payload.uuid) {
						historyStore.unsettled_bets.data[betslip_index].bets[bet_index].status = payload.status;
						if (bet.settlement == null) {
							if (payload.status == 'available') {
								historyStore.unsettled_bets.data[betslip_index].bets[bet_index].current_price = payload.price;
							} else {
								historyStore.unsettled_bets.data[betslip_index].bets[bet_index].current_price = null;
							}
						}
					}
				});
			});
		},
		setFixtureOddInfoInsert(payload) {
			const historyStore = useHistoryStore();
			historyStore.unsettled_bets.data.forEach((betslip, betslip_index) => {
				betslip.bets.forEach((bet, bet_index) => {
					if (bet.uuid == payload.uuid) {
						historyStore.unsettled_bets.data[betslip_index].bets[bet_index].status = payload.status;
						if (bet.settlement == null) {
							if (payload.status == 'available') {
								historyStore.unsettled_bets.data[betslip_index].bets[bet_index].current_price = payload.price;
							} else {
								historyStore.unsettled_bets.data[betslip_index].bets[bet_index].current_price = null;
							}
						}
					}
				});
			});
		},
		setFixtureOddInfoUpdate(payload) {
			const historyStore = useHistoryStore();
			historyStore.unsettled_bets.data.forEach((betslip, betslip_index) => {
				betslip.bets.forEach((bet, bet_index) => {
					if (bet.uuid == payload.uuid) {
						// Apply changes from update patch (delta)
						payload.patch.forEach(patch => {
							if (patch.path.includes('price') && bet.settlement == null) {
								historyStore.unsettled_bets.data[betslip_index].bets[bet_index].current_price = patch.value;
							} else if (patch.path.includes('status')) {
								historyStore.unsettled_bets.data[betslip_index].bets[bet_index].status = patch.value;
							}
						});

						// Disable cashout when odd is not available
						if (bet.status != 'available' && bet.settlement == null) {
							historyStore.unsettled_bets.data[betslip_index].bets[bet_index].current_price = null;
						}
					}
				});
			});
		},
		setFixtureOddInfoDelete(payload) {
			const historyStore = useHistoryStore();
			historyStore.unsettled_bets.data.forEach((betslip, betslip_index) => {
				betslip.bets.forEach((bet, bet_index) => {
					if (bet.uuid == payload && bet.settlement == null) {
						historyStore.unsettled_bets.data[betslip_index].bets[bet_index].current_price = null;
					}
				});
			});
		},

	},
	persist: {
		//
	},
})